<template>
   <div class="sort-dropdown">
      <button v-click-outside="hide" @click="toggleSortDrop" :class="{focused: showSortlist}">
         <span v-if="selected === ''">SORT by {{label}}</span>
         <span v-else>SORT by {{selected}}</span>
      </button>
      <div id='sort_list' v-if="showSortlist">
         <a v-for="sortItem in sortItems" :key="sortItem.text" @click="showSortlist=false; selected=sortItem.text; handleSortChange(sortItem.attr);">
            {{sortItem.text}}
         </a>
      </div>
   </div>
</template>

<script>
export default {
   data() {
      return {
         showSortlist: false,
         sortItems: [],
         selected: '',
      }
   },

   props: {
      label: '',
      reset: Boolean
   },

   created() {
      this.getSortItems();
   },

   methods: {
      toggleSortDrop() {
         this.showSortlist = !this.showSortlist;
      },

      hide() {
         this.showSortlist = false;
      },

      handleSortChange() {
         //implment in child
      },

      // sortChange(sortItem) {
      //    this.$parent.$emit('SortChanged', sortItem);
      // },

      getSortItems() {
         //set up by children
      }
   },

   watch: {
      reset() {
         this.selected = '';
      }
   }
}
</script>

<style lang="scss">
.sort-dropdown {
  
  button {
      width: 170px;
      overflow: hidden;
      border-radius: 4px; 
      background: url('../assets/img/instances/SVGs/thin-arrow-right.svg') no-repeat 90% center;
      background-size: 7px 12px; 
      text-align: left;
      cursor: pointer;

      &.focused {
        background-image: url('../assets/img/instances/SVGs/thin-arrow-down.svg'); 
        background-size: 12px 7px; 
        outline: none !important;
      }

      span {
         display: block;
         max-width: 80%;
         overflow: hidden;
         white-space: nowrap;
         text-overflow: ellipsis;
      }
  }

  #sort_list {

    a {
      display: block;
      padding-left: 14px;
      text-decoration: none;
      line-height: 30px;
      color: inherit;
      cursor: pointer;

      &:last-of-type {
        border-bottom: 0;
      }
    }
  }
}
</style>
